import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Download/index.tsx");
